import { j as e } from "./jsx-runtime-DmTjM30f.mjs";
import { I as m, a as x } from "./ic_arrowforward_fill-DIQoCdSY.mjs";
import "react";
import { c as o } from "./tw-cn-mXgPecoF.mjs";
import { I as d } from "./icon-button-DImUgRzQ.mjs";
const i = ({
  a11yLabel: a,
  onClick: t,
  icon: s,
  className: l
}) => /* @__PURE__ */ e.jsx(
  d,
  {
    "aria-label": a,
    className: o(l, "aspect-auto w-100"),
    icon: s,
    onClick: t,
    size: "small",
    theme: "outlined_basic",
    title: a
  }
), n = (a) => "0".repeat(Math.max(2, String(a).length)), r = ({ align: a = "left", bold: t = !1, value: s }) => /* @__PURE__ */ e.jsx("span", { className: `min-w-28 flex-1 truncate text-${a} ${t ? "font-bold" : ""}`.trim(), children: typeof s == "number" ? String(s).padStart(2, "0") : s }), u = ({
  currentPage: a,
  totalPages: t,
  onClickPrevious: s,
  onClickNext: l,
  className: c
}) => /* @__PURE__ */ e.jsxs("div", { className: o(c, "flex items-center justify-center"), children: [
  /* @__PURE__ */ e.jsx(
    i,
    {
      a11yLabel: "이전",
      icon: /* @__PURE__ */ e.jsx(m, { className: "size-20 text-text-neutral-main" }),
      onClick: s
    }
  ),
  /* @__PURE__ */ e.jsxs("div", { className: "mx-4 flex min-w-68 max-w-158 flex-col items-center justify-center tabular-nums typography-body-14-regular", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex w-full text-text-neutral-main", children: [
      /* @__PURE__ */ e.jsx(r, { align: "right", bold: !0, value: a }),
      /* @__PURE__ */ e.jsx("span", { className: "mx-4", children: "/" }),
      /* @__PURE__ */ e.jsx(r, { value: t })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { "aria-hidden": "true", className: "h-0 overflow-hidden whitespace-nowrap", children: [
      /* @__PURE__ */ e.jsx(r, { align: "right", bold: !0, value: n(t) }),
      /* @__PURE__ */ e.jsx("span", { className: "mx-4", children: "/" }),
      /* @__PURE__ */ e.jsx(r, { value: n(t) })
    ] })
  ] }),
  /* @__PURE__ */ e.jsx(
    i,
    {
      a11yLabel: "다음",
      icon: /* @__PURE__ */ e.jsx(x, { className: "size-20 text-text-neutral-main" }),
      onClick: l
    }
  )
] });
u.displayName = "NDS.PageController";
export {
  u as P
};
